export default __webpack_public_path__ + "static/media/gallery_00.a6f3a139.jpg";